import { logOutUser } from '../redux/user/user.action';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useGlobalDarkMode } from 'hooks/useDarkMode';

const AppBar = ({ ...otherProps }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const isDarkModeActive = useGlobalDarkMode();
  
  // Check if we're on stencils page and dark mode is active
  const isStencilsPage = location.pathname === '/stencils';
  
  return (
    <div
      className={`w-full h-14 bg-white flex flex-row items-center justify-end border-b-1 border-gray-100 shadow-sm appbar ${
        isStencilsPage && isDarkModeActive ? 'dark-mode-active' : ''
      }`}
      {...otherProps}
    >
      <div className="mr-5">
        <button
          className="bg-red-500 rounded-lg p-2 text-white hover:bg-red-600"
          onClick={() => {
            dispatch(logOutUser(navigate));
          }}
        >
          LogOut
        </button>
      </div>
    </div>
  );
};

export default AppBar;
